export default __webpack_public_path__ + "static/favicon-6d741fdc527385149957dc7023423a88.png";